import AxiosBusiness from '@/services/api/business/axios_business'

export default {
  // Format Instance endpoints
  createFormatInstance: (data) => {
    return AxiosBusiness.post('format-instance', data)
  },

  updateFormatInstance: (formatInstanceId, data) => {
    return AxiosBusiness.put(`format-instance/${formatInstanceId}`, data)
  },

  deleteFormatInstance: (formatInstanceId) => {
    return AxiosBusiness.delete(`format-instance/${formatInstanceId}`)
  },

  getFormatInstance: (formatInstanceId) => {
    return AxiosBusiness.get(`format-instance/${formatInstanceId}`)
  },

  getFormatInstancesByBaseInstance: (baseInstanceId, params = {}) => {
    return AxiosBusiness.get(`format-instance/base-instance/${baseInstanceId}`, { params })
  },
}
